import React from "react";
import { Link } from "react-router-dom";
import topics from "../../data/atlasTopics.json";
import AtlasGraphBackdrop from "./AtlasGraphBackdrop";
import { trackCTAClick } from "../../utils/analytics";
import "../../styles/Explore.css";

// Three ways into the Atlas, each showing a real fragment of the graph rather
// than a screenshot or an icon.
//
// Every number and herb name on these cards is derived at build time from the
// graph itself (scripts/build-atlas-seed.js) — not typed in. Hand-written copy
// drifts: an early draft of this section claimed Peppermint and Chamomile for
// digestion when the actual graph returns Ginger, Cinchona and Devil's Claw.
// If the data changes, the cards change with it.

const ExploreSection = () => (
  <section className="sv-dark sv-section explore">
    <div className="sv-wrap">
      <h2 className="sv-h2 sv-center explore__title">Start anywhere</h2>
      <p className="sv-body sv-center explore__intro">
        Each of these is a live corner of the same graph. Open one and follow it
        as far as the evidence goes.
      </p>

      <div className="sv-grid-3">
        {topics.map((topic) => (
          <Link
            key={topic.key}
            to={`/atlas?node=${topic.slug}&type=condition`}
            className="sv-card sv-card--link explore__card"
            onClick={() =>
              trackCTAClick(`explore_${topic.key}`, "home-explore")
            }
          >
            <div className="sv-card__media explore__media">
              <AtlasGraphBackdrop
                seed={topic}
                intensity={1}
                spread={0.62}
                density={34}
              />
            </div>

            <h3 className="sv-h4 explore__card-title">{topic.title}</h3>

            <p className="explore__stats">
              <strong>{topic.herbCount}</strong> plants
              {topic.clinicalCount > 0 && (
                <>
                  {" · "}
                  <strong>{topic.clinicalCount}</strong> with human data
                </>
              )}
            </p>

            <p className="sv-body explore__blurb">{topic.blurb}</p>

            {topic.topHerbs && topic.topHerbs.length > 0 && (
              <p className="explore__herbs">{topic.topHerbs.join(" · ")}</p>
            )}

            <span className="explore__more">Open in the Atlas →</span>
          </Link>
        ))}
      </div>

      <p className="sv-center explore__all">
        <Link
          to="/atlas"
          onClick={() => trackCTAClick("explore_see_all", "home-explore")}
        >
          See the whole graph →
        </Link>
      </p>
    </div>
  </section>
);

export default ExploreSection;
